import { BASE_URL } from 'common/config.js'

export function authBySessionUnderAttack({ router, urlPath, session }) {
  const route = router.resolve(decodeURIComponent(urlPath.replace(BASE_URL, '')))
  if (!route) {
    return
  }

  if (session) {
    return { name: 'session-auth', query: { url: route.fullPath, session } }
  }
}
